<vault-organization-user-notifications></vault-organization-user-notifications>
<app-vault-banners [organizations]="organizations$ | async"></app-vault-banners>

<app-vault-header
  [filter]="filter"
  [loading]="refreshing && !performingInitialLoad"
  [organizations]="allOrganizations"
  [canCreateCollections]="canCreateCollections"
  [collection]="selectedCollection"
  (onAddCipher)="addCipher($event)"
  (onAddCollection)="addCollection()"
  (onAddFolder)="addFolder()"
  (onEditCollection)="editCollection(selectedCollection.node, $event.tab)"
  (onDeleteCollection)="deleteCollection(selectedCollection.node)"
  (onOpenAddItemDialog)="openAddItemDialog()"
></app-vault-header>

<app-vault-onboarding [ciphers]="ciphers"></app-vault-onboarding>

<div class="bv-listing-page tw-flex tw-flex-row -tw-mx-2.5">
  <div class="bv-listing-page__column tw-basis-3/4 tw-max-w-3/4 tw-px-2.5">
    @if (activeFilter.isDeleted) {
      <bit-callout type="warning">
        {{ trashCleanupWarning }}
      </bit-callout>
    }

    @if (showSubscriptionEndedMessaging$ | async) {
      <bit-callout type="subtle" [title]="'premiumSubscriptionEnded' | i18n">
        <ng-container>
          <div>
            {{ "premiumSubscriptionEndedDesc" | i18n }}
          </div>
          <a bitLink href="#" appStopClick (click)="navigateToGetPremium()">
            {{ "restartPremium" | i18n }}
          </a>
        </ng-container>
      </bit-callout>
    }

    <div
      class="bv-vault-listing"
      [class.bv-vault-listing--empty]="isEmpty && !performingInitialLoad"
    >
      <div class="bv-vault-listing__header">
        <h2 class="bv-vault-listing__title">{{ "allVaults" | i18n }}</h2>
        <div class="bv-vault-listing__header-actions">
          @if (vaultBatchBarService.selectedCount() > 0) {
            <button
              type="button"
              class="bv-vault-listing__delete-btn"
              bitIconButton="bwi-trash"
              [label]="'delete' | i18n"
              [disabled]="vaultBatchBarService.canDelete() === false"
              (click)="listingBulkDelete()"
            ></button>
          }
          <bit-search
            class="bv-vault-listing__search"
            id="vault-listing-search"
            placeholder="{{ filterComponent()?.searchPlaceholder ?? 'searchVault' | i18n }}"
            [ngModel]="currentSearchText$ | async"
            (ngModelChange)="filterSearchText($event)"
            autocomplete="off"
          />
        </div>
      </div>

      <app-vault-items
        #vaultItems
        [ciphers]="ciphers"
        [collections]="collections"
        [allCollections]="allCollections"
        [allOrganizations]="allOrganizations"
        [disabled]="refreshing"
        [showOwner]="true"
        [showCollections]="false"
        [showGroups]="false"
        [showPremiumFeatures]="canAccessPremium"
        [showBulkMove]="showBulkMove"
        [showBulkTrashOptions]="filter.type === 'trash'"
        [useEvents]="false"
        [showAdminActions]="false"
        [showBulkAddToCollections]="true"
        [userCanArchive]="userCanArchive$ | async"
        [enforceOrgDataOwnershipPolicy]="enforceOrgDataOwnershipPolicy$ | async"
        (onEvent)="onVaultItemsEvent($event)"
      >
      </app-vault-items>
      @if (performingInitialLoad) {
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12">
          <i
            class="bwi bwi-spinner bwi-spin tw-text-muted"
            title="{{ 'loading' | i18n }}"
            aria-hidden="true"
          ></i>
          <span class="tw-sr-only">{{ "loading" | i18n }}</span>
        </div>
      }
      @if (isEmpty && !performingInitialLoad) {
        <div class="bv-vault-listing__empty">
          <bit-no-items
            [icon]="(emptyState$ | async)?.icon"
            [class.bv-vault-empty-state]="showAddCipherBtn"
          >
            <div slot="title">
              {{ (emptyState$ | async)?.title | i18n }}
            </div>
            <p slot="description" bitTypography="body2" class="tw-max-w-md tw-text-center">
              {{ (emptyState$ | async)?.description | i18n }}
            </p>
            @if (showAddCipherBtn) {
              <button
                type="button"
                [buttonType]="btnTextAddCreateFeatureFlag() ? 'secondary' : 'primary'"
                bitButton
                (click)="addCipher()"
                slot="button"
                [startIcon]="btnTextAddCreateFeatureFlag() ? null : 'bwi-plus'"
              >
                {{ (btnTextAddCreateFeatureFlag() ? "addItem" : "newItem") | i18n }}
              </button>
            }
          </bit-no-items>
        </div>
      }
    </div>
  </div>
  <div class="bv-listing-page__column tw-basis-1/4 tw-max-w-1/4 tw-px-2.5">
    <app-vault-filter
      #vaultFilter
      [activeFilter]="activeFilter"
      [searchText]="currentSearchText$ | async"
      (searchTextChanged)="filterSearchText($event)"
      (onEditFolder)="editFolder($event)"
    ></app-vault-filter>
  </div>
</div>

@if (vaultBatchBarFeatureFlag()) {
  <bit-vault-batch-action />
}
